export const Dining = () => (
  <section id="dining" data-testid="dining-section" className="sr-only" aria-label="Dining and Bar">
    Dining and bar details are covered in the Guesthouse overview.
  </section>
);
